import { ICountry } from "Models/Country";
import customFetchBase from "./customFetchBase";
import { createApi } from "@reduxjs/toolkit/query/react";


export const countryApi = createApi({
    reducerPath: "countryApi",
    baseQuery: customFetchBase,
    tagTypes: ["Country"],
    keepUnusedDataFor: 300,  // Mantener en caché por 5 minutos
    refetchOnReconnect: true, // Recargar datos al reconectarse
    refetchOnFocus: true, // Recargar datos al enfocar la ventana
    endpoints: (builder) => ({
        getCountryByCode: builder.query<string, { code: string; language: string }>({
            query: ({ code, language }) => ({
                url: `country/${code}/${language}`,
                method: "GET",
                credentials: "include",
            }),
            providesTags: ["Country"],
            transformResponse: (result: { data: string }) => result.data, // Extraer solo el nombre del país
        }),
        getAllCountries: builder.query<ICountry[], void>({
            query: () => ({
                url: "country/",
                method: "GET",
                credentials: "include",
            }),
            providesTags: ["Country"],
            transformResponse: (result: { data: ICountry[] }) => result.data, 
        })

    }),
});

export const { useGetCountryByCodeQuery,useGetAllCountriesQuery } = countryApi;
